import { useMachine } from '@xstate/react'
import { AxiosResponse } from 'axios'
import React from 'react'
import { ColplRouting, useColplRouting } from '../containers/App/RouterApp'
import { useClaimant } from '../context/col'
import { CaseReportRespType } from '../models'
import load, { CaseReportGetParams } from '../services/case-report/load'
import fetchMachine from '../statecharts/fetchMachine'

interface UseGetDataInterface {
  onData?: (data: CaseReportRespType, params: CaseReportGetParams) => void
}

export default function <P>({ onData }: UseGetDataInterface) {
  const { state, dispatch } = useClaimant()
  const colplRouting: ColplRouting = useColplRouting()
  const promiseFn = getDataCase({ id: state.caseReportId! })
  const [current, send] = useMachine(fetchMachine, {
    context: { promiseFn },
  } as any)

  const { data, error, params } = current.context
  //@ts-ignore
  if (error && error!.response?.status === 401) {
    // DONE refaktorovat reakci na Unauthorized pro GET /case-report/{id}
    colplRouting.goToCaseRefresh()
    // nelze: return !!! hook musi vzdy neco vratit
  }
  React.useEffect(() => {
    if (current.matches('failure')) {
      dispatch({
        type: 'error',
        payload: {
          // @ts-ignore
          error: error!.response?.data?.message ?? 'An error happened',
        },
      })
    }
  }, [current.value])

  React.useEffect(() => {
    if (current.matches('success')) {
      // @ts-ignore
      //const initialData = transformCaseReportRespToOrigPayload(data)
      /*const typeForDispatch = () => {
        console.log(state.caseType, 'state-caseType')
        if (state.caseType === 'ME') return 'load_data_ME'
        return 'load_data'
      }
      dispatch({
        type: typeForDispatch(),
        payload: initialData,
      })*/
      dispatch({
        type: 'load_case_data',
        payload: { loadedCaseReportResp: data },
      })
      if (onData) {
        onData(data! as CaseReportRespType, params! as CaseReportGetParams)
      }
    }
  }, [current.value])

  const fetch = React.useCallback(
    (args?: P) => send({ type: 'FETCH', params: args } as any),
    []
  )
  return {
    pending: current.matches('fetching'),
    data,
    fetch,
  }
}

export const getDataCase = (
  params: CaseReportGetParams
): (() => Promise<CaseReportRespType>) => {
  return async () => {
    try {
      //console.log(params, 'CaseReportGetParams')
      const res: AxiosResponse<CaseReportRespType> = await load(params)
      return res.data
    } catch (error) {
      // console.log(error.message)
      throw error
    }
  }
}

/*export const transformCaseReportRespToOrigPayload = (
  caseReportResp: CaseReportRespType
) => {
  console.log(caseReportResp, 'caseReportResp')
  const attachmentsList = caseReportResp.attachmentList?.find(
    (list: AttachmentListRespType) => list.attachmentType === 'POLICY'
  )
  return { ...caseReportResp, attachments: attachmentsList?.attachments ?? [] }
}*/
